import "./MoveInput.less";

const ChevronUp = () => (
   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g stroke-width="0" />
      <g stroke-linecap="round" stroke-linejoin="round" />
      <path
         d="m6 15 6-6 6 6"
         stroke="#000"
         stroke-width="2"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </svg>
);

const ChevronDown = () => (
   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g stroke-width="0" />
      <g stroke-linecap="round" stroke-linejoin="round" />
      <path
         d="m6 9 6 6 6-6"
         stroke="#000"
         stroke-width="2"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </svg>
);

const MoveInput = ({ onMove }) => {
   return (
      <div className="form-builder-input-move">
         <button onClick={() => onMove("up")}>
            <ChevronUp />
         </button>
         <button onClick={() => onMove("down")}>
            <ChevronDown />
         </button>
      </div>
   );
};

export default MoveInput;
